import React from "react";
import SectionTitle from "../components/SectionTitle";
import { useLang } from "../context/LangContext";
import { ASSETS } from "../lib/content";
import ContactForm from "../components/ContactForm";

export default function Exomobil() {
  const { lang } = useLang();
  return (
    <main className="pt-32" data-testid="page-exo">
      <section className="container-luxe py-16">
        <SectionTitle eyebrow="EXOMOBIL" title={lang === "fr" ? "L'unité mobile, redéfinie." : "The mobile unit, redefined."} subtitle={lang === "fr" ? "Châssis noir et titane. Silence acoustique. Soin clinique premium à votre adresse." : "Black and titanium chassis. Acoustic silence. Premium clinical care at your address."} />
      </section>
      <section className="container-luxe pb-16">
        <img src={ASSETS.exomobil_action} alt="Exomobil exoskeleton in action" className="w-full h-[520px] object-cover rounded-md hairline" />
      </section>
      <section className="container-luxe pb-12">
        <img src={ASSETS.exomobil} alt="Hypershell Exo Pro X" className="w-full h-[460px] object-contain bg-white rounded-md hairline" />
      </section>
      <section className="container-luxe pb-24 grid grid-cols-1 md:grid-cols-3 gap-px hairline">
        {[{k:"Acoustique",v:"<28 dB"},{k:"Autonomie",v:"8h"},{k:"Modules",v:"4 protocoles"}].map((m)=>(
          <div key={m.k} className="bg-surface-1 p-8" data-testid={`exo-${m.k}`}>
            <div className="overline">{m.k}</div>
            <div className="font-display text-3xl text-[var(--ink)] mt-2 font-light">{m.v}</div>
          </div>
        ))}
      </section>
      <section className="container-luxe pb-24"><ContactForm source="exomobil" /></section>
    </main>
  );
}
